import Config from 'config/settings';
import { Module } from 'core/Module';
import { Events } from 'core/events/Events';
import { TextScramble } from 'utils/TextScramble';
import DelayHelper from 'utils/timers';
import { Simple } from 'utils/analytics';

export class Paging extends Module {
	public config = {
		activeIndex: 0,
		freezeInteractionOnClick: 0,
		track: true
	};

	private _$items: NodeListOf<HTMLElement>;
	private $title: HTMLElement;
	private _onClick: Function;
	private _checkIndex: number;
	private _guideCycleInt: number;
	private _guideIndex: number = 0;
	private _oldGuideIndex: number;
	private _guideDirection: number = 1;
	private _freezeClick: boolean = false;
	private _label: string = '';

	private _textScrable: TextScramble;
	private _shownAtStart: boolean = false;
	//DelayHelper.setTimeout id (number | string); also passed to native clearTimeout
	//at the call site, which does not cancel DelayHelper timers (pre-existing quirk):
	private _timeout: any;
	private _type: string = null;

	private _labelsScreens: Array<string> = [
		'',
		'GLOBAL CAMPAIGN  _  OOH / ONLINE',
		'CASUAL GAMING  _  MOBILE',
		'playful learning  _  online',
		'VIRTUAL PRODUCTION  _  VFX / MOTION CAPTURE'
	];

	private _labelsSpaces: Array<string> = [
		'',
		'VIRTUAL PRODUCTION  _  VFX / MOTION CAPTURE',
		'INSTALLATION  _  VR',
		'INSTALLATION  _  AR',
		'MENTAL WELLBEING  _  VR'
	];

	private get _labels(): Array<string> {
		if ((window as any).mode == 'lite') {
			return [
				'',
				'GLOBAL CAMPAIGN  _  OOH / ONLINE',
				'VIRTUAL PRODUCTION  _  VFX / MOTION CAPTURE',
				'CASUAL GAMING  _  MOBILE',
				'INSTALLATION  _  VR',
				'INSTALLATION  _  AR',
				'playful learning  _  online',
				'MENTAL WELLBEING  _  VR'
			];
		}

		return this._type === 'screens' ? this._labelsScreens : this._labelsSpaces;
	}

	public get totalItems() {
		return this._$items.length;
	}

	public create(): void {
		this.active = false;
		this._$items = this.$container.querySelectorAll('.ui__paging__item');
		this.DOM.addClass(this.$container, `-items-${this._$items.length}`);
		this.DOM.addClass(this._$items[this.config.activeIndex], '-selected');

		this._type = this.$container.dataset.type;

		this._guideIndex = this.config.activeIndex;

		let itemSelector = `#${this.id} .ui__paging__link`;
		Events.on('click', itemSelector, this._itemClick.bind(this));
		Events.on('mouseover', itemSelector, (e: MouseEvent) => e.preventDefault());



		this.$title = this.$container.querySelector('.ui__paging__title');

		if (this._labels) {
			return;
			this._textScrable = new TextScramble(this.$title, 15);
			this._textScrable.setText('');
			Events.on('work_copy_hidden', () => this.changeTileState(false));
			Events.on('work_slide_stopped', (index) => this.workSlideStopped(index));
		}
	}

	public setCallbacks(click: Function): void {
		this._onClick = click;
	}

	/** set container  for when manually creating the module */
	public setContainer(element: HTMLElement): void {
		this.$container = element;
		this.mounted = true;
	}

	public hide(type: string = 'cascade', delay: number = 0): void {
		this.DOM.removeClass(this.$container, '-show');
	}

	public show(type: string = 'cascade', delay: number = 0): void {

		this.DOM.addClass(this.$container, '-show');
		DelayHelper.setTimeout(() => {
		}, 900);
	}

	public setActiveIndex(index: number, forDisplayPurposesOnly: boolean = false): void {
		let oldIndex = this.config.activeIndex;


		if (!forDisplayPurposesOnly) {
			this.config.activeIndex = index;
		} else {
			oldIndex = this._oldGuideIndex;
		}

		this.config.activeIndex = index;

		this.DOM.removeClass(this._$items[oldIndex], '-selected');

		if (index > oldIndex) {
			this.DOM.addClass(this._$items[oldIndex], '-reverse');
			this.DOM.removeClass(this._$items[index], '-reverse');
		} else {
			this.DOM.removeClass(this._$items[oldIndex], '-reverse');
			this.DOM.addClass(this._$items[index], '-reverse');
		}

		this.DOM.addClass(this._$items[index], '-selected');

		for (let i = 0; i < this._$items.length; i++) {
			this.DOM.removeClass(this.$container, '-selectedindex' + i);
		}

		this.DOM.addClass(this.$container, '-selectedindex' + index);
	}

	public getActiveIndex(): number {
		if (this._guideCycleInt) {
			return 0;
		}

		return this.config.activeIndex;
	}

	/** Get the slug off the paging item */
	public getActiveSlug(index: number): string {
		return this._$items[index].getAttribute('data-slug');
	}

	/** Use a ratio to check what paging should be selected */
	public checkIndexFromRatio(ratio: number): number {
		this._checkIndex = Math.round(this._$items.length * ratio);

		if (this._checkIndex !== this.config.activeIndex) {
			this.setActiveIndex(this._checkIndex);
		}

		return this.config.activeIndex;
	}

	/** Start guid effect */
	public startGuideEffect(animate: boolean = true): void {
		this.DOM.addClass(this.$container, '-guide');

		if (!animate) {
			return;
		}

		clearInterval(this._guideCycleInt);
		this._guideCycleInt = setInterval(() => {
			this._guideCycle();
		}, 1000);
	}

	/** Stop the guide from animating (Used to guide the user) */
	public removeGuideEffect(selectIndex: number = null): void {
		if (!this._guideCycleInt) {
			return;
		}

		clearInterval(this._guideCycleInt);
		this._guideCycleInt = null;
		this.DOM.removeClass(this.$container, '-guide');
		if (selectIndex !== null) {
			this.setActiveIndex(selectIndex);
		}
	}

	/** Reset */
	public reset(): void {
		clearInterval(this._guideCycleInt);
		this._guideIndex = 0;
	}

	/** Set active */
	public setActive(active: boolean): void {
		if (active) {
			this.DOM.addClass(this.$container, '-active');
			return;
		}

		this.DOM.removeClass(this.$container, '-active');
	}

	public removeClass(className: string): void {
		this.DOM.removeClass(this.$container, className);
	}

	public showFromWork() {
	}

	public showTitle(delay = 0): void {
		return;
		gsap.TweenMax.to(this.$title, 0.5, { opacity: 1, delay: delay, ease: Config.linearEase });
	}

	//Private
	//----------------------------------------------------------------------------------------------------
	//----------------------------------------------------------------------------------------------------
	//----------------------------------------------------------------------------------------------------
	//----------------------------------------------------------------------------------------------------

	private _itemClick(e: MouseEvent): boolean {
		e.preventDefault();

		if (this._freezeClick) {
			return false;
		}

		let index = parseInt(this.DOM.getAttribute(e.target, 'data-index'));
		if (this._onClick) {
			this._onClick(index);
		}

		if (this.config.track) {
		}

		Simple.event('paging_item_click ', { index: index });

		if (this.config.freezeInteractionOnClick > 0) {
			this._freezeClick = true;
			DelayHelper.setTimeout(() => (this._freezeClick = false), this.config.freezeInteractionOnClick * 1000);
		}

		return false;
	}

	private _guideCycle(): void {
		this._oldGuideIndex = this._guideIndex;
		this._guideIndex += this._guideDirection;

		if (this._guideIndex === this._$items.length - 1 || this._guideIndex === 0) {
			this._guideDirection *= -1;
		}

		this.setActiveIndex(this._guideIndex, true);
	}

	private changeTileState(show: boolean) {
		if (!this.active) {
			return;
		}

		if (this.DOM) {
			this.DOM.toggleClass(this.$title, '-show', show);
		}
	}

	private workSlideStopped(index: number) {
		if (!this.active) {
			return;
		}

		if (!this.DOM) {
			return;
		}

		if (index <= 0) {
			this._shownAtStart = false;
			this._label = '';

			this.DOM.addClass(document.querySelector('.home-swipe-prompt'), '-show');
			return;
		}

		if (this._label != this._labels[index]) {
			this._label = this._labels[index];
			this.DOM.setText(this.$title, this._labels[index]);

		}

		if (index != 0) {
			let timeout = 10;
			if (index == 1 && !this._shownAtStart) {
				this.changeTileState(false);
				this._shownAtStart = true;
				timeout = 300;
			}

			clearTimeout(this._timeout);
			this._timeout = DelayHelper.setTimeout(() => this.changeTileState(true), timeout);
		}

	}
}
